module.exports = __webpack_public_path__ + "static/media/campion.e3f9253d.svg";